import { roundCloseButton } from '@project/theme-buttons'
//import { ButtonIconActiveHeight } from '@kit/components/IconButton.vue'
import { ModalPositionCenter } from '@kit/components/Modal.vue'

export const modal = {
  windowAutoPosition: true,
  position: ModalPositionCenter,
  backgroundClasses: "ics-modal-background",
  windowClasses: "ics-modal-window",
  closeButton: roundCloseButton
  
  // {
  //   ...modalButton, 
  //   icon:"rounded-close-x_50", 
  //   iconDimension: {
  //     style: ButtonIconActiveHeight,
  //     active: "20px"
  //   },
  //   background: {
  //     ...modalButton.background,
  //     borderRadius: "50%"   
  //   },
  // }
}